import { GlobalMethods } from './Helpers/GlobalMethods';
import Toastify from 'toastify-js'

// declare my helper in the window interface
declare global {
    interface Window {
        GlobalMethods: GlobalMethods
        toasts:  Record<string, Toastify>
        DoNotReloadOnColorboxClose: boolean,
        "$": any
    }
}

// Can access your methods with window.SiteMethods.theMethodName()
window.toasts = window.toasts || {} as Record<string, Toastify>;
window.GlobalMethods = new GlobalMethods();
window.DoNotReloadOnColorboxClose = true;